import { TimerRefreshOutlineIcon } from './TimerRefreshOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 406B38E4-1E8C-4493-A1DF-804BB1FCD620
 * name timer-refresh-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-refresh-outline.svg
 * tags
 * - Date / Time 
 */
export const StopwatchRefreshOutlineIcon = TimerRefreshOutlineIcon;
export default StopwatchRefreshOutlineIcon